import React from 'react';
import { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
import { Stack, Text } from '@atlaskit/primitives/compiled';
import Button from '@atlaskit/button/new';
import { JiraModal as Modal } from '@atlassian/jira-modal/src/ui/jira-modal.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { Interactions } from '@atlassian/jira-autodev-common/src/common/constants.tsx';
import messages from './messages.tsx';

type Props = {
	onRestart: () => void;
	onCancel: () => void;
};

export const RestartConfirmationModal = ({ onRestart, onCancel }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<Modal
			messageId="autodev-agent-picker.ui.picker-content.restart-confirmation-modal.modal"
			messageType="transactional"
			onClose={onCancel}
		>
			<ModalHeader>
				<ModalTitle appearance="warning">{formatMessage(messages.headerTitle)}</ModalTitle>
			</ModalHeader>
			<ModalBody>
				<Stack space="space.150">
					<Text as="p">{formatMessage(messages.warningText)}</Text>
					<Text as="p">{formatMessage(messages.confirmationText)}</Text>
				</Stack>
			</ModalBody>
			<ModalFooter>
				<Button
					appearance="default"
					onClick={onCancel}
					testId="autodev-agent-picker.ui.picker-content.restart-confirmation-modal.cancel-button"
				>
					{formatMessage(messages.cancelButtonText)}
				</Button>
				<Button
					// eslint-disable-next-line jira/ufo/valid-labels
					interactionName={Interactions.AGENT_RESTART_JOB_BUTTON}
					appearance="warning"
					onClick={onRestart}
					testId="autodev-agent-picker.ui.picker-content.restart-confirmation-modal.restart-button"
				>
					{formatMessage(messages.restartButtonText)}
				</Button>
			</ModalFooter>
		</Modal>
	);
};
